import { QueryClientProvider } from '@tanstack/react-query'
import { PostHogProvider } from 'posthog-js/react'
import { useEffect } from 'react'
import { I18nextProvider } from 'react-i18next'
import { createBrowserRouter, RouterProvider } from 'react-router-dom'
import { AppToaster } from '@/components/AppToaster'
import { BotpressChat } from '@/components/BotpressChat'
import { CookieConsent } from '@/components/CookieConsent'
import { useAuthStore } from '@/features/auth/store'
import { initAnalytics, posthog } from '@/lib/analytics'
import i18n from '@/lib/i18n'
import { queryClient } from '@/lib/queryClient'
import { AppRoutes } from '@/router/routes'

// Re-init on load when consent was already granted in a previous session.
initAnalytics()

// Data router (useBlocker l'exige) ; les routes restent déclarées en JSX dans
// AppRoutes, montées sous une unique route splat.
const router = createBrowserRouter(
  [
    {
      path: '*',
      element: (
        <>
          <AppRoutes />
          <AppToaster />
          <CookieConsent />
          <BotpressChat />
        </>
      ),
    },
  ],
  { future: { v7_relativeSplatPath: true } },
)

export function App() {
  const initialize = useAuthStore((s) => s.initialize)
  const isInitialized = useAuthStore((s) => s.isInitialized)

  useEffect(() => {
    void initialize()
  }, [initialize])

  if (!isInitialized) {
    return (
      <div className="min-h-screen flex items-center justify-center text-muted">
        Chargement…
      </div>
    )
  }

  return (
    <PostHogProvider client={posthog}>
      <I18nextProvider i18n={i18n}>
        <QueryClientProvider client={queryClient}>
          <RouterProvider router={router} future={{ v7_startTransition: true }} />
        </QueryClientProvider>
      </I18nextProvider>
    </PostHogProvider>
  )
}
